import { cn } from '@utils/cn';
import { type ComponentProps } from 'react';

const TimeLineFooter = ({
  className,
  children,
  ...props
}: ComponentProps<'footer'>) => {
  return (
    <footer className={cn('mt-3 grid', className)} {...props}>
      {children}
    </footer>
  );
};

export { TimeLineFooter };
